import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=d921dac6&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=d921dac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d921dac6",
  null
  
)

export default component.exports